import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className", "disabled", "expanded", "defaultExpanded", "onToggle"];
import React, { forwardRef, useCallback, useEffect, useMemo, useState } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { useAccordionClassName } from './utils';
import { AccordionRoot } from './style';
import { accordionDefaultTheme } from './theme';
import { ACCORDION_CLASS_PREFIX, accordionRoot } from './constants';
import AccordionContext from './AccordionContext';
export var Accordion = forwardRef(function Accordion(_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      expanded = _ref.expanded,
      _ref$defaultExpanded = _ref.defaultExpanded,
      defaultExpanded = _ref$defaultExpanded === void 0 ? false : _ref$defaultExpanded,
      onToggle = _ref.onToggle,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(ACCORDION_CLASS_PREFIX, accordionDefaultTheme);

  var _useState = useState(defaultExpanded),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var classOverride = useAccordionClassName(ACCORDION_CLASS_PREFIX, className, disabled, isExpanded);
  var handleHeaderToggle = useCallback(function (event) {
    setIsExpanded(!isExpanded);

    if (onToggle) {
      onToggle(event, !isExpanded);
    }
  }, [isExpanded, onToggle]);
  useEffect(function () {
    if (typeof expanded === 'boolean' && expanded !== isExpanded) {
      setIsExpanded(expanded);
    }
  }, [expanded]);
  var contextValue = useMemo(function () {
    return {
      disabled: disabled,
      isExpanded: isExpanded,
      onToggle: handleHeaderToggle
    };
  }, [disabled, isExpanded, handleHeaderToggle]);
  return React.createElement(AccordionContext.Provider, {
    value: contextValue
  }, React.createElement(AccordionRoot, Object.assign({
    "data-testid": accordionRoot
  }, restProps, {
    className: classOverride.Root,
    isExpanded: isExpanded,
    ref: ref,
    theme: theme,
    disabled: disabled
  }), children));
});
Accordion.displayName = ACCORDION_CLASS_PREFIX;
Accordion.defaultProps = {
  defaultExpanded: false,
  disabled: false
};